import { useTranslation } from 'react-i18next'
import PlanMealLogger from '../nutrition/PlanMealLogger'
import { nextPlannedMeal } from '../../utils/eatToday'

/** VH-248: the plan's next meal, and the plan's one-tap logging (VH-229's PlanMealLogger, reused
 *  as it is — the phone page adds no second way to log a plan meal). Nothing when there is no plan
 *  for today. */
export function NextPlannedMeal({ plan, date, onLogged }) {
  const { t } = useTranslation()
  if (!plan) return null
  const next = nextPlannedMeal(plan, date)
  const kcal = next?.totals?.kcal

  return (
    <section className="bg-surface-container rounded-lg border border-gray-200 p-4 space-y-2" data-testid="eat-next-planned">
      <h2 className="text-base font-semibold text-gray-900">{t('eat.planned')}</h2>
      <p className="text-sm text-gray-800" data-testid="eat-next">
        {next
          ? t('eat.nextPlanned', { meal: t(`weeklyPlan.slot.${next.slot}`) })
            + (kcal ? ` · ${Math.round(kcal)} kcal` : '')
          : t('eat.planDone')}
      </p>
      <PlanMealLogger embedded date={date} onLogged={onLogged} />
    </section>
  )
}

export default NextPlannedMeal
